import React from "react";
import GiftCardProgressBar from "../common/GiftCardProgressBar";
import { NextandBackGiftCardButton } from "../../common/GiftCardsButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "../../../utils/toast";
import {
  purchaseGiftCard as purchaseGiftCardThunk,
} from "../../../services/giftCardService";
import {
  setPurchaseResult,
  setLoading
} from "../../../redux/slices/giftCardCheckoutSlice";
const GiftCardConfirmPayPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { card, amount, details,loading } = useSelector(
    (s) => s.giftCardCheckout
  );
const { purchaseToken } = useSelector((state) => state.giftCardCheckout);
console.log("purchase token",purchaseToken);

  if (!card) {
    return (
      <div className="p-6">
        No gift card selected.{" "}
        <button
          onClick={() => navigate("/gift-cards")}
          className="underline text-blue-600"
        >
          Pick one
        </button>
      </div>
    );
  }
// const calculateTotalWithFee = (amount) => {
//   const fixedFee = 0.30;
//   const percentageFee = 0.017 * amount;
//   return parseFloat((amount + fixedFee + percentageFee).toFixed(2));
// };


const calculateTotalWithFee = (amount) => {
  const fixedFee = 0.30;
  const percentageFee = 0.017 * amount;
  const total = amount + fixedFee + percentageFee;

  // use Math.round for precise rounding to 2 decimals
  return Math.round((total + Number.EPSILON) * 100) / 100;
};

const handlePurchase = async () => {
  // if (!amount || !details?.firstName || !details?.email) {
    if (!amount) {
    // toast?.error?.("Please complete recipient details and amount.");
     toast?.error?.("Please enter amount.");
    return;
  }

  try {
    dispatch(setLoading(true));

    const finalAmount = calculateTotalWithFee(Number(amount));

    const payload = {
      contentProviderCode:
        card.contentProviderCode ||
        card.providerCode ||
        card.contentProvider ||
        card._id,
      amount: finalAmount, 
      // recipientDetails: details,
      token: purchaseToken,
    };

    const res = await dispatch(purchaseGiftCardThunk(payload)).unwrap();
    const checkoutUrl =
      res.checkoutUrl || res.data?.checkoutUrl || res.url || res.checkout_url;

    dispatch(setPurchaseResult(res));

    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    } else {
      console.log("error");
    }
  } catch (err) {
    console.error("Purchase error:", err);
  } finally {
    dispatch(setLoading(false));
  }
};



  return (
    <div className="max-w-4xl mx-auto min-h-screen bg-white p-4">
      <GiftCardProgressBar
        // steps={["Select", "Enter Details", "Confirm & Pay", "Thank You"]}
           steps={["Select", "Confirm & Pay", "Thank You"]}
        currentStep={1}
      />

      <div className="pt-5">
        <div>
          <h2 className="text-sm lg:text-md font-semibold text-black mb-3 lg:text-xl">
            Confirm & place your order
          </h2>
          <p className="text-[#8C8C8C] text-[12px] lg:text-sm font-[400]">
            Please confirm your order is correct and click **Pay Now** to
            proceed to secure checkout.
          </p>
        </div>
        <div className="mt-5">
          <h2 className="text-sm lg:text-md font-semibold text-black mb-3 lg:text-xl">
            Order summary
          </h2>
          <div className="bg-[#F2F4F5] p-4 rounded-lg space-y-3">
            <div className="w-full">
              <h2 className="text-sm lg:text-md font-medium text-black lg:text-xl">
                Product
              </h2>
              <ul className="flex justify-between items-center text-[#8C8C8C] text-[12px] lg:text-sm font-[400] border-b border-[#E0E0E0] pb-2">
                <li>1 x {card.productName}</li>
                <span>${amount}</span>
              </ul>
            </div>
<div className="w-full">
  <ul className="text-[#8C8C8C] border-b border-[#E0E0E0] space-y-2 pb-2">
    <div className="text-[12px] lg:text-sm font-[400] flex justify-between items-center">
      <li>Subtotal</li>
      <span>${amount}</span>
    </div>
    <div className="space-y-1">
      <p className="text-[12px] lg:text-sm font-[400] flex justify-between items-center">
        <li>Processing Fee</li>
        {/* <span>${(0.30 + 0.017 * Number(amount)).toFixed(2)}</span> */}
        <span>${(Math.round((0.30 + 0.017 * Number(amount) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>

      </p>
      <div className="text-[8px] font-[400]">
        (Includes $0.30 + 1.7% of purchase amount)
      </div>
    </div>
  </ul>
</div>

<p className="flex justify-between items-center">
  <span className="text-sm lg:text-md font-medium text-black lg:text-xl">
    Total
  </span>
  <span className="text-[12px] lg:text-sm font-[400] text-[#8C8C8C]">
    ${calculateTotalWithFee(Number(amount))}
  </span>
</p>
          </div>
        </div>
      </div>

      <NextandBackGiftCardButton
        onNext={handlePurchase}
        onBack={() => navigate(-1)}
        nextText={loading ? "Processing..." : "Pay Now"}
        showBack
        showNext
      />
    </div>
  );
};

export default GiftCardConfirmPayPage;
